<template>
  <section>
    <elNavbar />
    <!-- Start Banner Hero -->
    <section class="bg-light">
      <div class="container py-4">
        <div class="row align-items-center justify-content-between">
          <div class="contact-header col-12 col-md-7">
            <h1 class="h2 pb-3 text-primary">About us</h1>
            <p class="light-300">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr,
            </p>
          </div>
          <div class="contact-img col-12 col-md-5">
            <img
              :src="
                $store.state.config.frontpoint + '/storage/About-us-page.png'
              "
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Banner Hero -->

    <!-- Start Team Member
    TODO: @hamid = Add Layout
    -->
    <article class="container py-5">
      <div class="pt-5 pb-3 d-lg-flex align-items-center gx-5">
        <div class="col-lg-3">
          <h2 class="h2 py-5 typo-space-line">Our Team</h2>
          <p class="text-muted light-300">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>

        <div class="col-lg-9 row">
          <div class="team-member col-md-4">
            <img
              class="team-member-img img-fluid rounded-circle p-4"
              :src="$store.state.config.frontpoint + '/storage/team-01.jpg'"
              alt="Card image"
            />
            <ul
              class="team-member-caption list-unstyled text-center pt-4 text-muted light-300"
            >
              <li>John Doe</li>
              <li>Business Development</li>
            </ul>
          </div>
          <div class="team-member col-md-4">
            <img
              class="team-member-img img-fluid rounded-circle p-4"
              :src="$store.state.config.frontpoint + '/storage/team-02.jpg'"
              alt="Card image"
            />
            <ul
              class="team-member-caption list-unstyled text-center pt-4 text-muted light-300"
            >
              <li>Jane Doe</li>
              <li>Media Development</li>
            </ul>
          </div>
          <div class="team-member col-md-4">
            <img
              class="team-member-img img-fluid rounded-circle p-4"
              :src="$store.state.config.frontpoint + '/storage/team-03.jpg'"
              alt="Card image"
            />
            <ul
              class="team-member-caption list-unstyled text-center pt-4 text-muted light-300"
            >
              <li>Sam</li>
              <li>Developer</li>
            </ul>
          </div>
        </div>
      </div>
    </article>
    <!-- End Team Member -->

    <!-- Start Our Partner -->
    <article class="bg-secondary py-3">
      <div class="container py-5">
        <h2 class="h2 text-white text-center py-5">Our Partner</h2>
        <div class="row text-center">
          <div class="col-md-3 mb-3">
            <div class="card partner-wap py-5">
              <a href="#"
                ><i class="display-1 text-white bx bxs-buildings"></i
              ></a>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <div class="card partner-wap py-5">
              <a href="#"
                ><i class="display-1 bx text-white bxs-check-shield bx-lg"></i
              ></a>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <div class="card partner-wap py-5">
              <a href="#"
                ><i class="display-1 text-white bx bxs-bolt-circle"></i
              ></a>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <div class="card partner-wap py-5">
              <a href="#"><i class="display-1 text-white bx bxs-spa"></i></a>
            </div>
          </div>
        </div>
      </div>
    </article>
    <!--End Our Partner-->

    <!-- Start Progress -->
    <article class="bg-white py-5">
      <div class="container my-4">
        <h1 class="creative-heading h2 pb-3">Creative & Make Perfect</h1>

        <div class="creative-content row py-3">
          <div class="col-md-5">
            <p class="text-muted col-lg-8 light-300">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis
              ipsum suspendisse ultrices gravida Risus.
            </p>
          </div>
          <div class="creative-progress col-md-7">
            <div class="row mt-4 mt-sm-2">
              <div class="col-6">
                <h4 class="h5">Development</h4>
              </div>
              <div class="col-6 text-right">66%</div>
            </div>
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                style="width: 66%"
                aria-valuenow="66"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>

            <div class="row mt-4 mt-sm-2">
              <div class="col-6">
                <h4 class="h5">Design</h4>
              </div>
              <div class="col-6 text-right">90%</div>
            </div>
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                style="width: 90%"
                aria-valuenow="90"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>

            <div class="row mt-4 mt-sm-2">
              <div class="col-6">
                <h4 class="h5">Marketing</h4>
              </div>
              <div class="col-6 text-right">74%</div>
            </div>
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                style="width: 74%"
                aria-valuenow="74"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <!-- End Progress -->

    <!-- Start Choice -->
    <article class="why-us banner-bg bg-light">
      <div class="container my-4">
        <div class="row">
          <div class="banner-img col-lg-5">
            <img
              :src="$store.state.config.frontpoint + '/storage/work.svg'"
              class="rounded img-fluid"
              alt=""
            />
          </div>
          <div class="banner-content col-lg-7 align-self-end">
            <h2 class="h2 pb-3">Why you choose us?</h2>
            <p class="text-muted pb-5 light-300">
              You are allowed to download and use this Purple Buzz template for
              your websites. You are <strong>not allowed</strong> to
              re-distribute this template ZIP file on other template websites.
              It is quite easy to simply copy and repost the ZIP file on any
              <a
                rel="nofollow"
                href="https://www.google.com/search?q=free+css"
                target="_blank"
                >Free CSS collection</a
              >
              websites.
            </p>
          </div>
        </div>
      </div>
    </article>
    <!-- End Choice -->

    <!-- Start Aim -->
    <article class="banner-bg bg-white py-5">
      <div class="container my-4">
        <div class="row text-center">
          <div class="objective col-lg-4">
            <div
              class="objective-icon card m-auto py-4 mb-2 mb-sm-4 bg-secondary shadow-lg"
            >
              <i class="display-4 bx bxs-bulb text-light"></i>
            </div>
            <h2 class="objective-heading h3 mb-2 mb-sm-4 light-300">
              Our Vision
            </h2>
            <p class="light-300">
              Incididunt ut labore et dolore magna aliqua. Quis ipsum
              suspendisse commodo viverra.
            </p>
          </div>

          <div class="objective col-lg-4 mt-sm-0 mt-4">
            <div
              class="objective-icon card m-auto py-4 mb-2 mb-sm-4 bg-secondary shadow-lg"
            >
              <i class="display-4 bx bx-revision text-light"></i>
            </div>
            <h2 class="objective-heading h3 mb-2 mb-sm-4 light-300">
              Our Mission
            </h2>
            <p class="light-300">
              Eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam quis.
            </p>
          </div>

          <div class="objective col-lg-4 mt-sm-0 mt-4">
            <div
              class="objective-icon card m-auto py-4 mb-2 mb-sm-4 bg-secondary shadow-lg"
            >
              <i class="display-4 bx bxs-select-multiple text-light"></i>
            </div>
            <h2 class="objective-heading h3 mb-2 mb-sm-4 light-300">
              Our Goal
            </h2>
            <p class="light-300">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor.
            </p>
          </div>
        </div>
      </div>
    </article>
    <!-- End Aim -->
    <elFooter />
  </section>
</template>

<script>
import elFooter from "../components/Footer.vue";
import elNavbar from "../components/Navbar.vue";

export default {
  name: "AboutMe",
  metaInfo: {
    title: "About Us",
    titleTemplate: "%s | NEW ABC APP",
  },
  components: {
    elFooter,
    elNavbar,
  },
  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },
  methods: {},
};
</script>
